module.exports = __webpack_public_path__ + "static/media/medium-v3100-Latin-Cyrillic.e82d5c6f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read-beta-2/medium-v3100-Latin-Cyrillic.woff2
// module id = 661
// module chunks = 0